import { useState, useRef } from 'react';
import { useIntl } from 'react-intl';
import { Row, Col } from 'src/componentes/grid';
import Dialog from 'src/componentes/dialog';
import Input from 'src/componentes/input';
import Button from 'src/componentes/button';
import ValidacaoEstagioStageGateLookup from 'src/lookups/ValidacaoEstagioStageGateLookup';

const StageValidateDialog = ({ onClose, onProceed }) => {
  const intl = useIntl();
  const refValidateDialog = useRef();

  const [stageApproveStatus, setstageApproveStatus] = useState(null);
  const [comment, setcomment] = useState(null);

  const handleCloseValidateDialog = () => {
    refValidateDialog.current?.close();
    onClose?.();
  };

  const handleProceed = () => {
    onProceed?.(stageApproveStatus, comment);
    refValidateDialog.current?.close();
    onClose?.();
  };

  const proceedDisabled =
    stageApproveStatus == null ||
    ((stageApproveStatus.key == 'reject' ||
      stageApproveStatus.key == 'suspend' ||
      stageApproveStatus.key == 'review') &&
      !comment);

  const actions = [
    <Button key={1} onClick={handleCloseValidateDialog} color="secondary">
      {intl.formatMessage({ id: 'label.cancelar' })}
    </Button>,
    <Button
      disabled={proceedDisabled}
      key={2}
      className="ml-2"
      onClick={handleProceed}
    >
      {intl.formatMessage({ id: 'avancar' })}
    </Button>,
  ];

  return (
    <Dialog
      title={intl.formatMessage({ id: 'validarEstagio' })}
      actions={actions}
      padContent
      minWidth={800}
      minHeight={300}
      ref={refValidateDialog}
      onRequestClose={handleCloseValidateDialog}
    >
      <Row>
        <Col>
          <ValidacaoEstagioStageGateLookup
            model={{
              value: stageApproveStatus,
              requestChange: setstageApproveStatus,
            }}
            placeholder={`${intl.formatMessage({ id: 'selecione' })}...`}
          ></ValidacaoEstagioStageGateLookup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Input
            rows={6}
            style={{ marginBottom: 0 }}
            type="textarea"
            placeholder={intl.formatMessage({ id: 'label.justificativa' })}
            model={{
              value: comment,
              requestChange: setcomment,
            }}
          />
        </Col>
      </Row>
    </Dialog>
  );
};

export default StageValidateDialog;
